import { isRunningInBrowser } from "../components/App";
import { Citation } from "../helpers/Models";
import { extension_endpoint } from "../utils/constants";

const url_cited_excerpt = extension_endpoint + "/cited_excerpt";

export const getExcerpt = async ({
  getToken,
  citation,
}: {
  getToken: () => Promise<string | null>;
  citation: Citation;
}) => {
  try {
    const token = await getToken();
    if (!isRunningInBrowser() && !token) {
      console.debug("CitedExcerpt -- no token, returning...");
      return;
    }
    const res = await fetch(url_cited_excerpt, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        citation: citation.text,
        citation_context: citation.context,
        opinion_id: citation.opinion_id,
      }),
    });
    const json = await res.json();
    return json;
  } catch (error) {
    console.log("getExcerpt err", error);
  }
};
